import { isRespondentOnly } from "@/domain/permissions";
import { useSystemOverTime } from "@/features/system/useLocationAnalyses";
import { useCurrentSystemAnalysis } from "@/features/system/useSystemAnalysis";
import { useI18n } from "@/i18n/useI18n";
import { useApp, useUi } from "./AppContext";
import { formatRegionSelection } from "./selectors";
import type { Tab } from "./urlState";

export function PageTitle({ tab }: { tab: Tab }) {
  const { t, language } = useI18n();
  const { authMode, user } = useApp();
  const { selectedRegions } = useUi();
  const { analysis, location } = useCurrentSystemAnalysis();
  const overTime = useSystemOverTime();
  const regions = formatRegionSelection(selectedRegions, t("allLocations"), t("locationsSelected"));

  let suffix: string;
  if (authMode === "individual" && isRespondentOnly(user)) {
    suffix = `${t("respondentPageTitle")}, ${user?.location || t("allLocations")}`;
  } else if (tab === "system" && overTime.active) {
    const { period, location: place } = overTime;
    const locationName =
      place.locationId === "all"
        ? t("systemFilterAllLocations") || t("allLocations")
        : (language === "en" ? place.locationName.en : place.locationName.no) || place.locationId;
    const years = period ? `${period.start}–${period.end}` : "";
    suffix = [t("systemOverTimeTitle"), years, locationName].filter(Boolean).join(", ");
  } else if (tab === "system") {
    const year = analysis?.year != null ? String(analysis.year).trim() : "";
    const locationName =
      !location || location.locationId === "all"
        ? t("systemFilterAllLocations") || t("allLocations")
        : (language === "en" ? location.locationName.en : location.locationName.no) ||
          location.locationId;
    suffix = [t("tabSystem"), year, locationName].filter(Boolean).join(", ");
  } else if (tab === "admin") {
    suffix = t("tabAdmin");
  } else {
    const tabLabel = { list: t("tabList"), matrix: t("tabMatrix"), stats: t("tabStats") }[tab];
    suffix = `${tabLabel}, ${regions}`;
  }

  return (
    <div className="top-bar">
      <div id="title">
        <span id="title-prefix">{t("title")}</span>
        <br />
        <h2 id="title-suffix">{suffix}</h2>
      </div>
    </div>
  );
}
